import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-saved-chat',
  templateUrl: './saved-chat.component.html',
  styleUrls: ['./saved-chat.component.scss']
})
export class SavedChatComponent implements OnInit {
  @Input() data: any[] = [];
  @Input() selectedChatId: number = 0;
  @Output() onClickChat: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onClickChatEvent(obj: any): void {
    this.onClickChat.emit(obj)
  }

}